import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import BackgroundImage from '../../assets/makers-viewers.webp'
import { Link, useNavigate } from 'react-router-dom'
import PictoMaker from '../../assets/picto-maker.svg'
import PictoViewer from '../../assets/picto-viewer.svg'
import StopIcon from '../../assets/stop-icon.svg'
import PlayIcon from '../../assets/play-icon.svg'
import { COLOR_WHITE, COLOR_ORANGE_LIGHT } from '../../lib/colors'
import IconAdd from '../../components/Icon/IconAdd'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    gap: '1em',
    '@media (max-width: 480px)': {
      flexWrap: 'wrap',
      height: 'auto',
    },
  },
  backgroundImage: {
    zIndex: '-1',
    width: '100%',
    objectFit: 'cover',
    position: 'absolute',
  },
  panel: {
    width: '50%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    color: COLOR_WHITE,
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '30px',
    '@media (max-width: 480px)': {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '2em',
    },
  },
  reverse: {
    '@media (max-width: 480px)': {
      flexDirection: 'row-reverse',
    },
  },
  pictoMaker: {
    height: '9em',
    '@media (max-width: 480px)': {
      height: '6em',
    },
  },
  pictoViewer: {
    height: '9em',
    '@media (max-width: 480px)': {
      height: '6em',
    },
  },
  title: {
    fontSize: '24pt',
    margin: 0,
    '@media (max-width: 480px)': {
      fontSize: '1.8em',
    },
  },
  button: {
    backgroundColor: COLOR_WHITE,
    borderRadius: '2em',
    display: 'flex',
    alignItems: 'center',
    gap: '0.8em',
    padding: '0.3em 1.4em',
    margin: '0.3em 0em',
    width: 'fit-content',
    color: COLOR_ORANGE_LIGHT,
    fontWeight: 700,
    letterSpacing: '-0.05em',
    fontSize: '1.7em',
    cursor: 'pointer',
    '@media (max-width: 480px)': {
      fontSize: '1em',
      padding: '0.5em 1em',
    },
  },
  customLayout: {
    height: 'auto',
    color: 'white',
    paddingRight: '5%',
    paddingLeft: '5%',
    paddingBottom: '5%',
  },
  advantages: {
    fontWeight: 600,
    fontSize: '1.2em',
    gap: '0.2em',
    padding: '0.2em 0.8em',
  },
  link: {
    textDecoration: 'none',
  },
  titleOutLined: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '128px',
    lineHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.03em',
    fontFamily: 'Helvetica Neue LT W05_75 Bd Ou',
    marginTop: '7.5%',
    marginBottom: '10%',
    whiteSpace: 'nowrap',
    '@media (max-width: 900px)': {
      fontSize: '2.5em',
      width: '100%',
    },
  },
  description: {
    fontSize: '1em',
    '@media (max-width: 480px)': {
      fontSize: '0.8em',
    },
  },
  pictoSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '@media (max-width: 480px)': {
      alignItems: 'center',
    },
  },
})

const MakerVsWatcher = () => {
  const { t } = useTranslation('translation')

  const navigate = useNavigate()

  const handleBeAViewer = () => {
    navigate('../be-a-viewer')
  }

  const handleBeAMaker = () => {
    navigate('../be-a-maker')
  }

  return (
    <div id="maker-watcher" className={css(styles.container)}>
      <img
        src={BackgroundImage}
        className={css(styles.backgroundImage)}
        alt="background image"
        width="100%"
        height="100%"
      />
      <div className={css(styles.panel)}>
        <div className={css(styles.pictoSide)}>
          <img
            src={PictoMaker}
            className={css(styles.pictoMaker)}
            alt="picto maker"
            width="auto"
            height="9em"
          />
          <div className={css(styles.titleOutLined)}>
            {t('pages.home.makerVsWatcher.makers')}
          </div>
        </div>
        <div>
          <h2 className={css(styles.title)}>
            {t('pages.home.makerVsWatcher.BeAMaker')}
          </h2>
          <p className={css(styles.description)}>
            {t('pages.home.makerVsWatcher.descriptionMaker')}
          </p>
          <span className="hpavantagesmaker">
            <Link
              to={{
                pathname: '/be-a-maker',
                hash: 'optimization',
              }}
              className={css(styles.link)}
            >
              <div className={css(styles.button, styles.advantages)}>
                <IconAdd color={'#EC503D'} />
                <span>{t('pages.home.makerVsWatcher.moreAdvantages')}</span>
              </div>
            </Link>
          </span>
          <span className="hpdevenirunmaker">
            <div className={css(styles.button)} onClick={handleBeAMaker}>
              <img src={StopIcon} alt="stop icon" width="auto" height="auto" />
              <span>{t('pages.home.makerVsWatcher.BecomeMaker')}</span>
            </div>
          </span>
        </div>
      </div>
      <div className={css(styles.panel, styles.reverse)}>
        <div className={css(styles.pictoSide)}>
          <img
            src={PictoViewer}
            className={css(styles.pictoViewer)}
            alt="picto viewer"
            width="auto"
            height="9em"
          />
          <div className={css(styles.titleOutLined)}>
            {t('pages.home.makerVsWatcher.viewers')}
          </div>
        </div>
        <div className={css(styles.textSideViewer)}>
          <h2 className={css(styles.title)}>
            {t('pages.home.makerVsWatcher.BeAViewer')}
          </h2>
          <p className={css(styles.description)}>
            {t('pages.home.makerVsWatcher.descriptionViewer')}
          </p>
          <span className="hpavantagesviewers">
            <Link
              to={{
                pathname: '/be-a-viewer',
              }}
              className={css(styles.link)}
            >
              <div className={css(styles.button, styles.advantages)}>
                <IconAdd color={'#EC503D'} />
                <span>{t('pages.home.makerVsWatcher.moreAdvantages')}</span>
              </div>
            </Link>
          </span>
          <span className="hp_devenirviewer">
            <div className={css(styles.button)} onClick={handleBeAViewer}>
              <img src={PlayIcon} alt="play icon" width="auto" height="auto" />
              <span>{t('pages.home.makerVsWatcher.Go')}</span>
            </div>
          </span>
        </div>
      </div>
    </div>
  )
}

export default MakerVsWatcher
